// extracted by mini-css-extract-plugin
export default {"container":"PaymentMenu_container__gYpVM","buttonAdd":"PaymentMenu_buttonAdd__5WiW8"};